import * as React from 'react'
import { Skeleton as ChakraSkeleton, Circle as SkeletonCircleNative, Stack } from '@chakra-ui/react'

export const Circle = React.forwardRef(
  function SkeletonCircle(props, ref) {
    const { size, ...rest } = props
    return (
      <SkeletonCircleNative size={size} asChild ref={ref}>
        <ChakraSkeleton {...rest} />
      </SkeletonCircleNative>
    )
  },
)

export const Text = React.forwardRef(function Text(props, ref) {
  const { noOfLines = 3, gap, ...rest } = props

  return (
    <Stack gap={gap} width='full' ref={ref}>
      {Array.from({ length: noOfLines }).map((_, index) => (
        <ChakraSkeleton
          height='4'
          key={index}
          {...props}
          _last={{ maxW: '80%' }}
          {...rest}
        />
      ))}
    </Stack>
  )
})

export const Skeleton = ChakraSkeleton
